import { UserRoles } from '@/enums';
import { PurchaseOrders } from '@/modules/purchase-orders/types';

const access_roles = {
  [PurchaseOrders.Pages.PURCHASE_ORDER]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.SERVICE_ENGINEER,
  ],
  [PurchaseOrders.Pages.PURCHASE_ORDER_DETAIL]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.SERVICE_ENGINEER,
  ],
};

export default access_roles;
